import isEmpty from 'lodash/isEmpty'
import { l } from '@manychat/manyui'

import { delay } from 'utils'
import * as managerSelectors from 'common/builder/selectors/managerSelectors'
import { alert } from 'common/core'
import { resetFlow } from 'common/flow/actions/flowActions'
import * as flowSelectors from 'common/flow/selectors/flowSelectors'
import * as API from 'constants/API'
import { getClientId } from 'utils/clientId'
import { anotherTabNotificationsListener } from 'utils/services/notificationsService'

import * as managerStateActions from './managerStateActions'

export function discardFlowChanges(managerId) {
  return async (dispatch, getState) => {
    const manager = managerSelectors.getById(getState(), managerId)

    if (!manager || !manager.flowId) {
      return
    }

    const managerFlow = flowSelectors.getById(getState(), manager.flowId)
    const { flow } = await dispatch({
      $fetch: [
        API.flow.endpoints.discardFlowChanges,
        {
          method: 'POST',
          body: JSON.stringify({
            ns: manager.flowId,
            client_id: getClientId(),
            // for retrieving aggregated stats content holder should be omitted, not empty, and not null
            ...(managerFlow.chId ? { content_holder: managerFlow.chId } : {}),
          }),
          headers: { 'Content-Type': 'application/json' },
        },
      ],
    })

    return dispatch(resetFlow(flow))
  }
}

export const draftPatched = (data) => {
  return async (dispatch, getState) => {
    dispatch(resetFlow(data.flow))

    const state = getState()
    const managers = managerSelectors.filter(state, { flowId: data.flow.ns, viewerMode: false })

    await window.Promise.all(
      managers.map((manager) => {
        if (!manager.builderId) {
          return null
        }

        const hasBatch = data.batch && !isEmpty(data.batch)
        if (hasBatch) {
          dispatch(
            managerStateActions.applyBuilderBatch(manager.id, data.batch, { keepChanged: true }),
          )
        }

        const hasCoordinates = data.coordinates && !isEmpty(data.coordinates)
        if (hasCoordinates) {
          dispatch(managerStateActions.applyBuilderCoordinates(manager.id, data.coordinates))
        }
        return dispatch(indicateUpdateIsApplying(manager.id))
      }),
    )

    if (managers.length) {
      alert(l.translate('Content was updated!'))
    }
  }
}

export const draftDiscarded = (data) => {
  return async (dispatch, getState) => {
    const state = getState()
    const managers = managerSelectors.filter(state, { flowId: data.flow.ns, viewerMode: false })

    for (const manager of managers) {
      dispatch(managerStateActions.removeBuilder(manager.id))
    }

    for (const manager of managers) {
      dispatch(managerStateActions.fetchFlowAndCreateBuilder(manager.id))
    }

    if (managers.length) {
      alert(l.translate('Content changes were discarded!'))
    }

    if (!managers.length) {
      dispatch(resetFlow(data.flow))
    }
  }
}

export const flowPublished = (data) => {
  return async (dispatch, getState) => {
    const state = getState()
    let managers = managerSelectors.filter(state, { flowId: data.flow.ns })

    const [clientId, managerId] = (data.client_id || '|').split('|')
    const sameClientId = clientId === getClientId()
    if (sameClientId && managerId) {
      managers = managers.filter((m) => m.id !== managerId)
    }

    for (const manager of managers) {
      dispatch(managerStateActions.removeBuilder(manager.id))
    }

    for (const manager of managers) {
      dispatch(managerStateActions.fetchFlowAndCreateBuilder(manager.id))
    }

    if (!sameClientId) {
      if (managers.length) {
        alert(l.translate('Content was published!'))
      }

      if (!managers.length) {
        dispatch(resetFlow(data.flow))
      }
    }
  }
}

export function flowRenamed(data) {
  return async (dispatch, getState) => {
    const item = dispatch(resetFlow(data.flow))

    const managers = managerSelectors.filter(getState(), { flowId: item.id })

    if (managers.length) {
      // alert('Content name was updated!')
    }
  }
}

export const draftUpdated = (data) => {
  return async (dispatch, getState) => {
    const state = getState()
    const managers = managerSelectors.filter(state, { flowId: data.flow.ns, viewerMode: false })

    for (const manager of managers) {
      dispatch(managerStateActions.removeBuilder(manager.id))
    }

    for (const manager of managers) {
      dispatch(managerStateActions.fetchFlowAndCreateBuilder(manager.id))
    }

    if (managers.length) {
      alert(l.translate('Content was updated!'))
    }

    if (!managers.length) {
      dispatch(resetFlow(data.flow))
    }
  }
}

export const indicateUpdateIsApplying = (managerId) => {
  return (dispatch, getState) => {
    return new window.Promise(async (resolve) => {
      dispatch(managerStateActions.updateManagerState(managerId, { isApplyingUpdate: true }))
      await delay(1000)
      if (managerSelectors.getById(getState(), managerId)) {
        dispatch(managerStateActions.updateManagerState(managerId, { isApplyingUpdate: false }))
      }
      resolve()
    })
  }
}

anotherTabNotificationsListener.on('flow_published', (data, dispatch) => {
  dispatch(flowPublished(data))
})
anotherTabNotificationsListener.on('flow_draft_patched', (data, dispatch) => {
  dispatch(draftPatched(data))
})
anotherTabNotificationsListener.on('flow_draft_updated', (data, dispatch) => {
  dispatch(draftUpdated(data))
})
anotherTabNotificationsListener.on('flow_changes_discarded', (data, dispatch) => {
  dispatch(draftDiscarded(data))
})
anotherTabNotificationsListener.on('flow_renamed', (data, dispatch) => {
  dispatch(flowRenamed(data))
})
